import { CSSProperties, memo } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import Box from '../Box';

interface IBuildSXParams {
  padding?: number | string;
  borderRadius?: number | string;
}

export interface IQRCodeProps extends IBuildSXParams {
  value: string;
  size?: number;
  level?: string;
  bgColor?: string;
  fgColor?: string;
  style?: CSSProperties;
  includeMargin?: boolean;
  imageSettings?: {
    src: string;
    height: number;
    width: number;
    excavate: boolean;
    x?: number;
    y?: number;
  };
}

const buildSX = ({ padding, borderRadius }: IBuildSXParams) => ({
  padding,
  borderRadius,
});

const QRCode = (props: IQRCodeProps) => {
  const {
    size = 200, padding = '45px', borderRadius = '0px', ...restProps
  } = props;

  return (
    <Box sx={buildSX({ padding, borderRadius })}>
      <QRCodeCanvas
        {...restProps}
        size={size}
      />
    </Box>
  );
};

export default memo(QRCode);
